import { Col , Row , Form , Input, Upload, message} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { useDispatch , useSelector } from 'react-redux'
import DefaultLayout from '../components/DefaultLayout'
import Spinner from '../components/Spinner'
import { addCar } from '../redux/actions/carsActions'
import axios from 'axios'
import API_BASE_URL from '../apiConfig'

function AddCar() {

    const dispatch = useDispatch()
    const {loading} = useSelector(state=>state.alertsReducer)
    const [imageUrl, setImageUrl] = useState('')
    const [uploading, setUploading] = useState(false)

    function onFinish(values){

         values.bookedTimeSlots=[]
         values.image = imageUrl

         if(!imageUrl){
             message.error('Please upload a car image')
             return
         }

         dispatch(addCar(values))
    }

    async function handleUpload({ file }){
        const user = JSON.parse(localStorage.getItem('user'))
        const formData = new FormData()
        formData.append('image', file)
        formData.append('userId', user._id)

        setUploading(true)
        try {
            const response = await axios.post(`${API_BASE_URL}/api/upload/image`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            setImageUrl(response.data.url)
            message.success('Image uploaded successfully')
        } catch (error) {
            console.log(error)
            message.error(error.response?.data || 'Image upload failed')
        }
        setUploading(false)
    }

    return (
        <DefaultLayout>
               {loading && (<Spinner />)}
               <Row justify='center mt-5'>
                   <Col lg={12} sm={24} xs={24} className='p-2'>
                       <Form className='bs1 p-2' layout='vertical' onFinish={onFinish}>
                           <h3>Add New Car</h3>
                           <hr />
                           <Form.Item name='name' label='Car name' rules={[{required: true}]}>
                               <Input/>
                           </Form.Item>

                           <Form.Item label='Car Image'>
                               <Upload
                                   customRequest={handleUpload}
                                   showUploadList={false}
                                   accept="image/*"
                               >
                                   <button type="button" className="btn1"><UploadOutlined /> {uploading ? 'Uploading...' : 'Upload Image'}</button>
                               </Upload>
                               {imageUrl && (
                                   <img src={imageUrl} alt="preview" style={{width:120, height:80, objectFit:'cover', borderRadius:8, marginTop:10, display:'block'}} />
                               )}
                           </Form.Item>

                           <Form.Item name='rentPerHour' label='Rent per hour' rules={[{required: true}]}>
                               <Input/>
                           </Form.Item>
                           <Form.Item name='capacity' label='Capacity' rules={[{required: true}]}>
                               <Input/>
                           </Form.Item>
                           <Form.Item name='fuelType' label='Fuel Type' rules={[{required: true}]}>
                               <Input/>
                           </Form.Item>

                           <div className='text-right'>
                           <button className='btn1'>ADD CAR</button>
                           </div>

                       </Form>
                   </Col>
               </Row>

        </DefaultLayout>
    )
}

export default AddCar
